// WubbleNotification.jsx
import React, { useEffect, useState } from "react";
import { Bell } from "@gravity-ui/icons";
import Notifications from "./ResponsiveNotification";
import apiService from "../../api/apiService";
import { getCookie } from "../../utils/cookieUtils";
import { io } from "socket.io-client";
import { useNotification } from "../../contexts/NotificationContext";
import { usePostHog } from "posthog-js/react";
import { getPartitionedLocalStorage } from "../../utils/tokenExtraction";


const socket = io(process.env.REACT_APP_SERVER_ENDPOINT);

const WubbleNotification = ({ modalPosition }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalTime, setOpenModalTime] = useState(null);
  const userId = getCookie("user_id") || getPartitionedLocalStorage("user_id");
  const [notificationCount, setNotificationCount] = useState(1);// Default to 1 to match feature updates
  const {unreadCount} = useNotification(); 
  const posthog = usePostHog();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const notificationBox = document.querySelector(".notification-container");
      if (
        notificationBox &&
        !notificationBox.contains(event.target) &&
        !event.target.closest(".notification-trigger")
      ) {
        setOpenModal(false);
      }
    };

    if (openModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openModal]);

  useEffect(() => {
    getNotifications();
    socket.connect();

    socket.on(`${userId}-notification`, (data) => {
      getNotifications();
      console.log("Notification received", data);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const getNotifications = async () => {
    // We keep this API call but prioritize showing feature update count
    await apiService.handleProtectedRoute(
      "fetchNewNotifications",
      {}
    );
    // We maintain the count at 1 to match the feature updates count
    // This would be dynamic in a real app based on what updates the user hasn't seen
  };

  const handleUpdateCount = (count) => {
    setNotificationCount(count);
  };

  return (
    <div className="w-full">
      <div className="flex justify-center w-full">
        <button
          onClick={() => {
            posthog.capture("Click-UpdateWidget-Sidebar", {
              is_user_logged_in: true,
              unread_count: unreadCount,
              timestamp: new Date().toISOString()
            });
            setOpenModal(true);
            setOpenModalTime(new Date());
          }}
          className="notification-trigger self-stretch h-9 px-3 bg-white/5 hover:bg-white/10 rounded-full inline-flex justify-between items-center gap-2 text-sm text-[#878188] hover:text-white transition-colors w-full"
        >
          <div className="flex items-center gap-2">
            <Bell className="w-3.5 h-3.5 object-contain" />
            <span className="">Updates</span>
          </div>
          {unreadCount > 0 && (
            <div className="h-4 min-w-4 px-1 bg-gradient-to-br from-[#FC10F2] to-[#3078E4] rounded-full inline-flex justify-center items-center text-[10px] text-white font-semibold">
              {unreadCount}
            </div>
          )}
        </button>
      </div>

      {openModal && (
        <div
          className="fixed inset-0 z-50"
          onClick={() => {
            posthog.capture("Close-NotificationPanel-Outside", {
              is_user_logged_in: true,
              method: "outside_click",
              panel_open_duration: Math.round((new Date() - openModalTime) / 1000) // in seconds
            });
            setOpenModal(false);
          }}
        >
          <div
            className="notification-container absolute text-white rounded-lg overflow-hidden w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "fixed",
              bottom: "20px",
              left: "230px",
              transform: "none",
              zIndex: 100,
              maxHeight: "80vh",
              background: "rgba(0, 0, 0, 0.1)",
              backdropFilter: "blur(20px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)"
            }}
          >
            <Notifications 
              onClose={() => {
                posthog.capture("Close-NotificationPanel-Button", {
                  is_user_logged_in: true,
                  method: "close_button",
                  panel_open_duration: Math.round((new Date() - openModalTime) / 1000) // in seconds
                });
                setOpenModal(false);
              }} 
              onUpdateCount={handleUpdateCount} 
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default WubbleNotification;